export default "__VITE_ASSET__GiRnk6d5__"